export default __webpack_public_path__ + "static/media/PuntoMeta.47bc3826.png";